webpackJsonp([142629428675168],{

/***/ 376:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"group":[{"node":{"excerpt":"\nLast week I decided to finally transition my current blog over to GatsbyJS. Because I wanted to generally just revamp the blog both content-wise and performance-wise.\n\n","frontmatter":{"title":"Welcome to My New Blog","path":"/my-new-blog/","date":"August 9, 2018"}}}],"pathPrefix":"","first":true,"last":true,"index":1,"pageCount":1,"additionalContext":{}}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-67a730f7c428186bde30.js